import React from 'react';
import StatCards from '../components/StatCards';
import Layout from '../components/Layout';
import StateGlobal from '../components/StateGlobal';


const StateGeneralPage = () => {
    return (
        <Layout>
             <StatCards />
            <StateGlobal />
        </Layout>
    );
};

export default StateGeneralPage;
